import { autoinject, customElement } from 'aurelia-framework';
import { CheckBoxBaseCustomElement } from 'General/Resources/Elements/CheckBox/CheckBoxBase';

@autoinject
@customElement('check-box')
export class CheckBoxCustomElement extends CheckBoxBaseCustomElement {}